import PropTypes from 'prop-types';
import React from 'react';
import ExpandIcon from '../ExpandIcon';

const AccordionFAQHeader = ({ onClick, expanded, headerText }) => (
  <div className="accordion-faq-header" onClick={onClick}>
    <span className="accordion-faq-header__text">{headerText}</span>
    <ExpandIcon expanded={expanded} />
  </div>
);

AccordionFAQHeader.propTypes = {
  onClick: PropTypes.func.isRequired,
  expanded: PropTypes.bool.isRequired,
  headerText: PropTypes.string.isRequired
};

export default AccordionFAQHeader;
